import { Tag } from '@loadsmart/loadsmart-ui'

export interface UUIDChipProps {
  uuid: string
  href?: string
  onClick?: (uuid: string) => void
  onAuxClick?: (uuid: string) => void
}

export default function UUIDChip({ uuid, href, onClick, onAuxClick }: UUIDChipProps) {
  const handleClick = () => {
    if (onClick) {
      onClick(uuid)
    }
  }

  const handleAuxClick = (e: React.MouseEvent) => {
    if (e.button === 1 && onAuxClick) {
      onAuxClick(uuid)
    }
  }

  const sliced = uuid.slice(0, 8) || '-'

  return (
    <a href={href} onClick={e => e.preventDefault()}>
      <Tag
        variant="default"
        onClick={handleClick}
        onAuxClick={handleAuxClick}
        className="cursor-pointer"
      >
        {sliced}
      </Tag>
    </a>
  )
}
